import { strIsNullOrEmpty, TextField } from '@fox/atoms';
import React, { useCallback, useState } from 'react';
import { useActionCentreContext, useFilterClearListener } from '../action-centre-context';
import { ActionCentreColumn } from '../contracts';

export function StringFilter({ column }: { column: ActionCentreColumn }) {
	const { setFilter } = useActionCentreContext();
	const [localValue, setLocalValue] = useState<string>('');

	// Listen for filter clear events and reset local state
	useFilterClearListener(
		useCallback(() => {
			setLocalValue('');
		}, [])
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setLocalValue(value);

			// Update context with debounce built into setFilter
			if (!strIsNullOrEmpty(value)) {
				setFilter(JSON.stringify({ contains: value }), column);
			} else {
				setFilter(undefined, column);
			}
		},
		[setFilter, column]
	);

	return <TextField value={localValue} onChange={handleChange} size="small" placeholder={column.title} />;
}
